import React, { useState } from 'react';
import propTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { uuidv4 } from '../../../utils/utility';
import '../input/input.scss';

const Textarea = ({
  name,
  disabled = false,
  tabIndex,
  values,
  label,
  value,
  rows,
  py,
  type,
  margin,
  error,
  className,
  language = {},
  inputClassName,
  placeholder,
  labelPosition,
  bottomClass,
  topClass,
  islocalization = true,
  themeMode,
  width,
  outSideLabel,
  outSideLabelClass,
  outSideLabelPosition,
  boxColor,
  heightSize,
  labelColor,
  parentClassName,
  positionLabel = false,
  ...rest
}) => {
  const id = uuidv4();
  return (
    <span id="inputContainer" className="w-100">
      <label
        id={`label${id}`}
        className={`w-100 d-flex ${margin} ${
          outSideLabel
            ? outSideLabelPosition === 'top'
              ? 'flex-column border-0 shadow-none'
              : 'shadow-none border-0'
            : `${`flex-row justify-content-between  
               ${error ? 'border border-danger' : ''} 
               ${
                 value && !error
                   ? labelColor
                     ? labelColor
                     : themeMode === 'dark'
                     ? 'darkInputSuccess'
                     : 'lightInputSuccess'
                   : ''
               }
               `}`
        } 
        ${className ? className : ''} 
        ${`${themeMode}-text-color`}
        `}
        style={{ width }}
      >
        {outSideLabel ? (
          <div
            className={`px-3 pb-2 ${outSideLabelClass}
        ${
          outSideLabelPosition === 'top'
            ? 'align-self-start text-start'
            : 'align-self-center'
        }
        ${outSideLabelPosition === 'side' ? 'w-25 text-start' : ''}
        
       ${
         labelColor
           ? labelColor
           : themeMode === 'light'
           ? `dark-text-color`
           : 'light-text-color'
       }
        `}
          >
            {islocalization ? (
              <FormattedMessage
                values={{ indx: values }}
                id={label}
                defaultMessage={label}
              />
            ) : (
              label
            )}
          </div>
        ) : (
          <label
            htmlFor={id}
            className={`text-start px-2 pt-2 ${
              value
                ? `position-validation-label`
                : positionLabel
                ? positionLabel
                : 'position-label'
            } 
              ${error ? 'text-danger' : ''}
              ${
                value && !error
                  ? labelColor
                    ? labelColor
                    : themeMode === 'light'
                    ? 'darkTextSuccess'
                    : 'lightTextSuccess'
                  : ''
              }
              `}
          >
            <span className={`${labelColor}`}>
              {islocalization ? (
                <FormattedMessage
                  values={{ indx: values }}
                  id={label}
                  defaultMessage={label}
                />
              ) : (
                label
              )}
            </span>
          </label>
        )}
        <span
          id={`inputContainer${id}`}
          className={`d-flex w-100 px-3 align-items-center justify-content-start ${
            parentClassName ? parentClassName : 'py-sm-2 py-1'
          } ${boxColor} ${boxColor ? boxColor : 'bg-third-light'}
        ${error ? ' border-danger' : ``}
        ${
          error
            ? 'error'
            : `${themeMode === 'light' ? 'lightsuccess' : 'darksuccess'}`
        }`}
          onFocus={() =>
            document
              .getElementById(`inputContainer${id}`)
              .classList.add('inputBoxShadow')
          }
          onBlur={() => {
            document
              .getElementById(`inputContainer${id}`)
              .classList.remove('inputBoxShadow');
          }}
          style={{
            borderRadius: '1rem',
            border: '1px solid rgb(189, 198, 243)',
          }}
        >
          <textarea
            {...rest}
            disabled={disabled}
            tabIndex={tabIndex}
            placeholder={error ? error : placeholder}
            id={`input${id}`}
            name={name}
            value={value || ''}
            rows={rows}
            className={`bg-third-light form-control px-2 w-100 border-0 ${
              inputClassName ? inputClassName : ''
            } ${
              outSideLabel
                ? `${`input-${themeMode}-mode  
              ${
                value && !error
                  ? themeMode === 'dark'
                    ? 'text-white '
                    : 'text-dark'
                  : ''
              }`}`
                : `${`border-0 
            ${
              value
                ? ` ${topClass ? topClass : 'paddingTop1-85rem'} ${
                    bottomClass ? bottomClass : 'pb-1'
                  } `
                : ''
            }`}`
            } m-0 custome-input-border  
          }`}
            style={{ outline: 0, resize: 'none' }}
          />
        </span>
      </label>
    </span>
  );
};
Textarea.propTypes = {
  name: propTypes.string,
  disabled: propTypes.bool,
  values: propTypes.string,
  label: propTypes.string,
  value: propTypes.string,
  rows: propTypes.number,
  py: propTypes.string,
  type: propTypes.string,
  margin: propTypes.string,
  error: propTypes.string,
  className: propTypes.string,
  inputClassName: propTypes.string,
  placeholder: propTypes.string,
  tabIndex: propTypes.string,
  labelPosition: propTypes.string,
  bottomClass: propTypes.string,
  topClass: propTypes.string,
  islocalization: propTypes.bool,
  themeMode: propTypes.string,
  width: propTypes.string,
  outSideLabel: propTypes.bool,
  outSideLabelClass: propTypes.string,
  outSideLabelPosition: propTypes.string,
  boxColor: propTypes.string,
  heightSize: propTypes.string,
  labelColor: propTypes.string,
};
Textarea.defaultProps = {
  name: '',
  disabled: false,
  values: '',
  rows: 5,
  label: 'Enter Your Label',
  value: '',
  py: 'py-sm-3',
  type: propTypes.oneOf[('text', 'password', 'checkbox', 'email', 'radio')],
  margin: '',
  error: '',
  className: 'label-font-responsive',
  inputClassName: '',
  placeholder: '',
  tabIndex: '',
  labelPosition: '',
  bottomClass: '',
  topClass: '',
  islocalization: true,
  themeMode: propTypes.oneOf[('dark', 'light')],
  width: '100%',
  outSideLabel: propTypes.oneOf[(true, false)],
  outSideLabelClass: '',
  outSideLabelPosition: propTypes.oneOf[('top', 'side')],
  boxColor: '',
  labelColor: '',
};
{
  /*
  ****Usage
  <Textarea
  name="LoginForm" --> name for input
  disabled={false} -->  true (editable) false (Read Only) Input
  values="Enter Password" -->for Localization
  label="Enter Label Value"
  value="this is value input" -->input value
  py="p-5" --> Add More bootstrap Class For Label
  type="text" -->Input Type
  margin="p-5" -->Bootstrap more Class For Container
  error:"wrong password"  -->input error
  inputClassName="Input Class Name" --> Input ClassName
  className="p-5" --> container class name
  onChange={this.handleInputOnChange} -->input onChange
  placeholder:"placeholder" -->input placeholder
  topClass="p-5" -->top class input (bootstrap)
  bottomClass="m-5" -->top class input (bootstrap)
  islocalization="true" --> if label is in in the i18n fro translate (true trsanslte )(false do not translate)
  outSideLabel=true --> true(nlabel out side input) false(label inside input)
  outSideLabelClass="bg-danger" --> if outSideLabel=true you can add class for outSideLabel
  outSideLabelPosition= "top" -->   if outSideLabel=true you can choose position of label  top or side
  />
*/
}
export default Textarea;
